import { client } from '../../../../../common-utils/libraries/axios/axios';
import { ORGANIZATION } from '../apiUrls';
import { buildUrl } from '../../../../../common-utils/functions/restUtils';

/**
 *
 * @param data
 * @returns {Object}
 */
function mapResponseData(data) {
    return data;
}

const queryGetOrganizationSimOffers = (params, enabled) => {
    return {
        queryKey: [ORGANIZATION.SIM_OFFERS.queryKey, params],
        queryFn: async () => {
            const response = await client.get(buildUrl(ORGANIZATION.SIM_OFFERS.url, params));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetOrganizationSimOffers;
